import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=4be43a91&scoped=true&"
import script from "./UserSidebar.vue?vue&type=script&lang=js&"
export * from "./UserSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=4be43a91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be43a91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be43a91')) {
      api.createRecord('4be43a91', component.options)
    } else {
      api.reload('4be43a91', component.options)
    }
    module.hot.accept("./UserSidebar.vue?vue&type=template&id=4be43a91&scoped=true&", function () {
      api.rerender('4be43a91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserSidebar.vue"
export default component.exports